import { useAPI } from "@sqreem-frontend/sqapp";
import { getCountryCode, getCountrySQSURL, getPackageObj, isCountryMongoAvailable, isCountryXMLAvailable, userRequestQueue, userResponseQueue } from "../utils/oneintelligence/OneIntelligenceHelper";
import { message, notification } from "antd";
import { createPromise, generateGUID, handleAPIError, isAdmin, isArray, isFlushCache, isLocal, updateOngoingApiCallList } from "../utils/MainHelper";
import TrackFeatureServices from "./TrackFeature.services";
import store from "../store/store";
import { setHasAccessToInsightsFeature, setHasAccessToPersonasFeature, setHasAccessToScrapeTopicBrandFeature, setIsWhitelabel } from "../store/components/BuildTargets.slice";
import { setModeOptionStatus } from "../store/components/Main.slice";
import WorkerServices from "./Worker.services";
import { setDisabledMOKB } from "../store/components/Feature.slice";

// eslint-disable-next-line react-hooks/rules-of-hooks
const SqAPI = useAPI();
class MainServices {
  constructor() {
    this.url = "https://api-3.sqreemtech.com/";
    // buckets
    this.savantReadBucket = "savant-result-inihaw"
    this.inihawBucket = "api-result-inihaw"
    this.treeBucket = "sqreem-inihaw-keywords"
    this.dashboardBucket = "sqreem-dashboard-files-inihaw"
    this.cgptBucket = "oneintelligence-cgpt"
    this.personaBucket = "oneintelligence-persona"
    this.audienceBucket = "onemarket-audience-manager"
    this.contextBucket = "oneintelligence-context"
    this.savantBucket = "savantbeterasponse"
    this.monitorBucket = "onemonitor"
    this.accountsBucket = "accountsmgr-media"
    this.sqgptBucket = "sqgpt"
    // paths
    this.permissionPath = "iamsession/getpermission";
    // temp vars
    this.urlsObj = {}
    this.userDetailsCache = {};


    this.reportsqsurl = "https://sqs.ap-southeast-1.amazonaws.com";
    this.reportsqs = "https://sqs.ap-southeast-1.amazonaws.com/788016873502/";
    this.guidurl = "lookup/getguid/";
  }

  urls(key, value) {
    if (value) this.urlsObj[key] = value
    return this.urlsObj[key]
  }

  getGUID() {
    return this.get({
      path: this.guidurl, options: {
        noCredentials: true,
      }
    }).then((data) => {
      return data?.guid;
    });
  }

  uploadFile(key, file, obj = {}, bucket = "inihaw") {
    return SqAPI.s3PutObject(this[bucket + "Bucket"], key, file, obj);
  }

  getFile(path, bucket = "inihaw", returnAsIs) {
    return SqAPI.s3GetObject(this[bucket + "Bucket"], path, {
      ResponseCacheControl: "no-cache"
    }).then((resp) => {
      if (returnAsIs) return resp
      const { Body } = resp;
      if (Body) {
        return JSON.parse(Body.toString("utf-8"));
      } else {
        return {}
      }
    }).catch(() => {
      return null
    })
  }

  smartApiCall(options, requestBody, statusCallBack = () => { }, monitorCallBack = () => { }) {
    // if (process.env.REACT_APP_OI_ISDEV) {
    //   const serverObj = OneIntelligenceServices.getSavantCountryObj(getCountryCode("savant"));
    //   return this.savantApiCall(
    //     options.gateway.function,
    //     requestBody,
    //     options,
    //     serverObj.server,
    //     serverObj.url
    //   );
    // }

    let newRequestBody = { ...requestBody, _app: "OILeg" };

    const isMongo = isCountryMongoAvailable()
    const isXML = isCountryXMLAvailable()
    const isFlush = isFlushCache()

    if (isFlush) {
      newRequestBody = {
        ...newRequestBody,
        generateCache: true,
        useCache: false
      };
    }

    if (isMongo) {
      newRequestBody = {
        ...newRequestBody,
        generateCache: false,
        useCache: false
      };
    }

    if (isXML) {
      newRequestBody = {
        ...newRequestBody,
        generateCache: true,
        useCache: true
      };
    }

    if (isFlush || isMongo) {
      newRequestBody = {
        ...newRequestBody,
        overwrite: true,
      };
    }

    if (options?.gateway?.function === "sspgetaudiencesize") {
      delete newRequestBody.generateCache
      delete newRequestBody.useCache
    }

    return this.createSQSRequest(options, newRequestBody, statusCallBack, monitorCallBack);
  }

  savantApiCall(fnc, request, opt = {}, server, url, cls) {
    const { promise, resolve } = createPromise();
    const startTime = new Date().getTime();

    let isStopPolling = false;
    const stopPolling = (isGet) => {
      if (isGet) {
        return isStopPolling;
      }
      isStopPolling = true;
      return isStopPolling;
    };
    const apiCallId = `${generateGUID()}~~ApiCall`;

    updateOngoingApiCallList({
      key: apiCallId,
      value: stopPolling
    });
    const { apiCancel, apiPromise } = SqAPI.post((url || this.url), request, opt);
    apiPromise.then(({ data: response, status }) => {
      if (status !== 200) {
        message.warning("Error in API call");
        resolve();
        return
      }
      if (!isLocal()) {
        let packageObj = {};
        try {
          packageObj = getPackageObj();
        } catch (error) {
          packageObj = {};
        }
        const logsObj = {
          masterOrSelection: request.masterOrSelection,
          masters: request.masters,
          region: request.region,
          server: request.server,
          package: request.package
        };
        if (request.marketPackage) logsObj.marketPackage = request.marketPackage;
        logsObj.marketPackageText = packageObj?.parent?.title || "";
        logsObj.moduleText = packageObj?.title || "";
        if (request.selections) logsObj.selections = request.selections;
        if (request.semCountry) logsObj.semCountry = request.semCountry;
        if (request.country) logsObj.country = request.country;
        if (request.items) logsObj.items = request.items;
        if (request.enterpriseCode) logsObj.enterpriseCode = request.enterpriseCode;
        if (request.title) logsObj.title = request.title;
        if (request.name) logsObj.name = request.name;
        const endTime = new Date().getTime();
        // window.gs.fSendCloudWatchRecord(this.url, cls, fnc, {}, (endTime - startTime) / 1000, undefined, logsObj);
      }
      const { _id: responseId } = response || {};
      if (!response) resolve(response);
      else if (response?.message?.includes("still loading")) {
        message.warning("Country is still loading please wait");
        resolve();
      } else if (responseId) {
        if (isStopPolling) {
          resolve();
        } else {
          if (isArray(responseId) && isArray(response.data)) {
            Promise.all(responseId.map(({ id, name, children }) => this.getComputeStatus(
              {
                _id: id,
                type: fnc,
                server: request.server || server
              },
              stopPolling
            ).then((resp) => {
              const newResp = { ...resp };
              newResp.data.name = name;
              newResp.data.tempChildren = children;
              return newResp;
            }))).then((resp) => {
              resolve({
                response: resp,
                data: response.data
              });
            });
          } else {
            this.getComputeStatus(
              {
                _id: responseId,
                type: fnc,
                server: request.server || server
              },
              stopPolling
            ).then((resp) => {
              resolve(resp);
            });
          }
        }
      } else {
        resolve(response);
      }
    }).catch((e) => {
      console.log(e);
      resolve();
    });
    return {
      promise: promise.then((response) => {
        updateOngoingApiCallList({ key: apiCallId }, "remove");
        if (response) {
          const { error, errorMsg } = response;
          if (error) {
            notification.error({
              message: errorMsg,
              description: "",
              duration: null,
              placement: "topRight",
              closable: true,
              key: "errorNotification"
            });
            return response;
          }
        }
        return response;
      }),
      stopPolling
    };
  }

  getComputeStatus(params, stopPolling = () => { }) {
    const { promise, resolve } = createPromise();
    const startTime = new Date().getTime();
    const getStatus = (parameters, stopPollingFnc) => {
      // const { apiCancel, apiPromise } = SqAPI.post(url, request, { noCredentials: true, ...opt });
      this.get({ path: "oneintel/getcomputestatus", params: parameters, options: { noCredentials: true } }).then((resp) => {
        const { status, response: ResMsg } = resp;
        const errorObj = {
          error: true,
          errorMsg: "Request timeout."
        };
        if (resp === 404 || status === 404) {
          console.error(ResMsg);
          resolve(errorObj);
        } else {
          const retryGetStatus = () => {
            setTimeout(() => {
              if (stopPollingFnc(true)) { resolve(); } else getStatus({ ...parameters }, stopPollingFnc);
            }, 2000);
          };
          if (status === 504 || resp === 504) {
            retryGetStatus();
          } else if (!resp) {
            resolve(errorObj);
          } else {
            if (resp.message === "PROCESSING.") {
              retryGetStatus();
            } else {
              resolve(resp);
            }
          }
        }
      });
    };
    getStatus(params, stopPolling);
    return promise.then((resp) => {
      const endTimeSqs = new Date().getTime();
      // if (!isLocal()) {
      //   window.gs.fSendCloudWatchRecord(this.urls, this.cls, "getcomputestatus", {}, (endTimeSqs - startTime) / 1000, undefined, params);
      // }
      return resp;
    });
  }

  createQueue(sessionId, fnc, givenQueueName, attributes) {
    const queuename = givenQueueName || this.scoreQueueName(fnc, sessionId);
    return this.sqsCreateQueue(queuename, attributes)
      .then((xml) => {
        if (xml.QueueUrl) {
          return {
            success: true,
            endPoint: this.scoreQueueURL(fnc, sessionId, givenQueueName)
          };
        }
        return null;
      })
      .catch((err) => ({
        error: true,
        errorMessage: err
      }));
  }

  createSQSRequest(options, requestBody, statusCallBack = () => { }, monitorCallBack = () => { }) {
    const sessionId = generateGUID();
    const { promise, resolve } = createPromise();

    let isStopPolling = false;
    const stopPolling = (isGet) => {
      if (isGet) {
        return isStopPolling;
      }
      isStopPolling = true;
      return isStopPolling;
    };
    const apiCallId = `${generateGUID()}~~ApiCall`;
    updateOngoingApiCallList({
      key: apiCallId,
      value: stopPolling
    });
    const {
      gateway: {
        function: fnc,
        class: cls
      }
    } = options;
    this.sendSqsMessage({
      sessionId,
      fnc,
      cls,
      requestBody,
      stopPolling,
      statusCallBack,
      monitorCallBack
    }).then(({ response, delete: deleteSQS }) => {
      const {
        _id: computeId, data, message: msg, isSuccess
      } = response || {};
      const toProceed = handleAPIError(msg, { url: this.urls, cls, fnc, isSuccess });
      if (toProceed?.error) {
        deleteSQS();
        resolve({ ...toProceed, ...response });
        return;
      }

      if (!isSuccess) {
        console.log(response);
      }
      if (computeId) {
        if (isArray(computeId) && isArray(data)) {
          Promise.all(computeId.map(({ id, name, children }) => this.getComputeStatus(
            {
              _id: id,
              type: fnc,
              server: requestBody.server
            },
            stopPolling
          ).then((resp) => {
            const newResp = { ...resp };
            newResp.data.name = name;
            newResp.data.tempChildren = children;
            return newResp;
          }))).then((resp) => {
            deleteSQS();
            resolve({
              response: resp,
              data: response.data
            });
          });
        } else {
          this.getComputeStatus(
            {
              _id: computeId,
              type: fnc,
              server: requestBody.server
            },
            stopPolling
          ).then((resp) => {
            deleteSQS();
            resolve(resp);
          });
        }
      } else {
        deleteSQS();
        resolve(response);
      }
    });

    return {
      promise: promise.then((response) => {
        updateOngoingApiCallList({ key: apiCallId }, "remove");
        if (response) {
          const { error, errorMsg } = response;
          if (error) {
            notification.error({
              message: errorMsg,
              description: "",
              duration: null,
              placement: "topRight",
              closable: true,
              key: "errorNotification"
            });
            return response;
          }
        }
        return response;
      }),
      stopPolling
    };
  }

  async sendSqsMessage({
    sessionId,
    fnc,
    cls,
    requestBody,
    stopPolling,
    statusCallBack = () => { },
    monitorCallBack = () => { }
  }) {
    const { promise, resolve } = createPromise();
    const account = this.getAccount();
    const { username } = this.userDetails();

    let endPoint = this.scoreQueueURL(fnc, sessionId)

    // if (isCountryXMLAvailable()) {
    //   endPoint = userResponseQueue()
    // }

    const sqsRequest = {
      ...requestBody,
      _class: cls,
      _function: fnc,
      _account: account,
      _username: username,
      _endpoint: endPoint
    };

    let sqsPayloadBody = sqsRequest;

    const jsonString = JSON.stringify(sqsRequest);
    const encoder = new TextEncoder();
    const jsonBytes = encoder.encode(jsonString);

    if (jsonString > 202144 || jsonBytes.byteLength > 202144) {
      const s3Path = await this.uploadSQSPayloadToS3(fnc, sessionId, sqsRequest);
      sqsPayloadBody = {
        _path: s3Path
      };
    }

    const createQueueAPI = () => {
      this.createQueue(sessionId, fnc).then((response) => {
        if (response && response.error) return response;
        const startTime = new Date().getTime();
        let sqsCountryURL = getCountrySQSURL();

        if (isCountryXMLAvailable()) {
          sqsCountryURL = userRequestQueue()
        }

        monitorCallBack(sqsCountryURL, sqsPayloadBody)
        return this.sqsSendMessage(sqsCountryURL, JSON.stringify(sqsPayloadBody))
          .then(() => {
            if (!isLocal()) {
              let packageObj = {};
              try {
                packageObj = getPackageObj();
              } catch (error) {
                packageObj = {};
              }
              const logsObj = {
                masterOrSelection: sqsRequest.masterOrSelection,
                masters: sqsRequest.masters,
                region: sqsRequest.region,
                server: sqsRequest.server,
                package: sqsRequest.package
              };
              if (sqsRequest.marketPackage) logsObj.marketPackage = sqsRequest.marketPackage;
              logsObj.marketPackageText = packageObj?.parent?.title || "";
              logsObj.moduleText = packageObj?.title || "";
              if (sqsRequest.selections) logsObj.selections = sqsRequest.selections;
              if (sqsRequest.semCountry) logsObj.semCountry = sqsRequest.semCountry;
              if (sqsRequest.country) logsObj.country = sqsRequest.country;
              if (sqsRequest.items) logsObj.items = sqsRequest.items;
              if (sqsRequest.enterpriseCode) logsObj.enterpriseCode = sqsRequest.enterpriseCode;
              if (sqsRequest.title) logsObj.title = sqsRequest.title;
              if (sqsRequest.name) logsObj.name = sqsRequest.name;
              const endTime = new Date().getTime();
              // window.gs.fSendCloudWatchRecord(
              //   sqsCountryURL,
              //   cls,
              //   fnc,
              //   { forceurl: true },
              //   (endTime - startTime) / 1000,
              //   undefined,
              //   logsObj
              // );
            }
            return this.receiveMessageSQS(sessionId, fnc, stopPolling, statusCallBack).then((res) => resolve(res));
          });
      });
    }

    let isCache = false;
    const cacheID = await WorkerServices.getObjectID([sqsPayloadBody, ["generateCache", "useCache", "_endpoint", "overwrite", "_app"]]);
    const enterpriseCode = getCountryCode("enterprise");

    const cachePath = `oneintel/cache_per_request_legacy`
    const newLocationPath = `${cachePath}/${enterpriseCode}/${cacheID}.json`
    const oldLocationPath = `${cachePath}/${cacheID}.json`

    if (window.useS3Cache && fnc !== "sspgetaudiencesize") {
      let cacheObj = await this.getFile(newLocationPath);
      if (!cacheObj) {
        cacheObj = await this.getFile(oldLocationPath);
      }

      if (cacheObj && cacheObj.isSuccess !== false) {
        isCache = true
        resolve({ response: cacheObj, delete: () => { } })
      } else {
        createQueueAPI()
      }
    } else {
      createQueueAPI()
    }

    return promise.then((resp) => {
      if (fnc !== "sspgetaudiencesize" && !isCache && newLocationPath) {
        this.uploadFile(newLocationPath, JSON.stringify(resp.response), {});
      }
      return resp
    })
  }

  xmlToJson(xml) {
    let obj = {};
    if (xml.nodeType === 1) {
      if (xml.attributes.length > 0) {
        obj["@attributes"] = {};
        for (let j = 0; j < xml.attributes.length; j++) {
          const attribute = xml.attributes.item(j);
          obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
        }
      }
    } else if (xml.nodeType === 3) {
      obj = xml.nodeValue;
    }
    if (xml.hasChildNodes()) {
      for (let i = 0; i < xml.childNodes.length; i++) {
        const item = xml.childNodes.item(i);
        const { nodeName } = item;
        if (typeof (obj[nodeName]) === "undefined") {
          obj[nodeName] = this.xmlToJson(item);
        } else {
          if (typeof (obj[nodeName].push) === "undefined") {
            const old = obj[nodeName];
            obj[nodeName] = [];
            obj[nodeName].push(old);
          }
          obj[nodeName].push(this.xmlToJson(item));
        }
      }
    }
    return obj;
  }

  xmlParser(xml) {
    const parser = new DOMParser();
    const xmlFormatted = parser.parseFromString(xml, "text/xml");
    return Promise.resolve(this.xmlToJson(xmlFormatted));
  }

  receiveMessageSQS(sessionId, fnc, stopPolling = () => { }, statusCallBack = () => { }) {
    const { promise, resolve } = createPromise();
    let hasID = false;
    let receipText = "";
    let objectToResolve = {};
    let stop = false;
    let interval = null;
    const doneComputing = () => {
      stop = true;
      if (receipText) { this.deleteApiMessage(sessionId, fnc, receipText); }
    };

    const receive = () => {
      if (stopPolling(true)) {
        doneComputing();
        resolve();
        return
      } else {
        console.log("recieve");
        let response_queue = this.scoreQueueURL(fnc, sessionId)

        // if (isCountryXMLAvailable()) {
        //   response_queue = userResponseQueue()
        // }

        this.sqsReceiveMessage(response_queue, 1, 10)
          .then((response) => {
            if (isCountryMongoAvailable() || isCountryXMLAvailable()) {
              try {
                const { Messages } = response;
                if (Messages && Messages.length) {
                  const { Body, ReceiptHandle } = Messages[0];
                  const { url, message, status } = JSON.parse(Body);

                  // Delete Message
                  if (ReceiptHandle)
                    this.deleteApiMessage(sessionId, fnc, ReceiptHandle);

                  if (status.toLocaleLowerCase() === "done") {
                    this.get({
                      options: { noCredentials: true, isQuery: false },
                      forcePath: url,
                    }).then((resp) => {
                      objectToResolve = { response: resp, delete: doneComputing };
                      resolve(objectToResolve);
                    });
                  } else if (status.toLocaleLowerCase() === "error") {
                    statusCallBack("Something went wrong.");
                    resolve();
                  } else {
                    receive();
                  }
                } else {
                  receive();
                }
              } catch (err) {
                console.log(err);
                receive();
              }
            } else {
              try {
                const { Messages } = response
                if (interval) {
                  if (Messages && Messages.Body) {
                    const { Body } = Messages;
                    const reponseObj = JSON.parse(Body);
                    if (reponseObj.status === "PROCESSING" && reponseObj.message) {
                      statusCallBack(`${reponseObj.message}.. please wait.`);
                    } else if (reponseObj.status === "ERROR") {
                      statusCallBack("Something went wrong.");
                      doneComputing();
                      resolve();
                      return
                    }
                  }
                  if (!stop) { receive(); }
                } else {
                  const checkReponse = (msg) => {
                    let receiveAgain = false;
                    if (msg && msg.Body) {
                      const { ReceiptHandle, Body } = msg;
                      const reponseObj = JSON.parse(Body);
                      if (reponseObj.isSuccess) {
                        receipText = ReceiptHandle;
                        setIntervalfunc();
                        resolve({ response: reponseObj, delete: doneComputing });
                      } else {
                        if (reponseObj.status === "PROCESSING" && reponseObj.message) {
                          const [first, second] = reponseObj.message.split(" ")[0].split("/");
                          if (parseInt(first, 10) === parseInt(second, 10) && Object.keys(objectToResolve).length) {
                            setIntervalfunc();
                            resolve(objectToResolve);
                          } else {
                            receiveAgain = true;
                            statusCallBack(`${reponseObj.message}.. please wait.`);
                          }
                        } else {
                          if (!hasID) {
                            hasID = true;
                            receipText = ReceiptHandle;
                            objectToResolve = { response: reponseObj, delete: doneComputing };
                            statusCallBack("Something went wrong.");
                            stopPolling()
                            resolve(objectToResolve)
                          } else {
                            receiveAgain = true;
                          }
                        }
                      }
                    } else {
                      receiveAgain = true;
                    }
                    return receiveAgain;
                  };
                  if (isArray(Messages)) {
                    if (Messages.map((msg) => checkReponse(msg)).includes(true)) {
                      receive();
                    } else {
                      receive();
                    }
                  } else {
                    if (checkReponse(Messages)) {
                      receive();
                    }
                  }
                }
              } catch (err) {
                receive();
              }
            }
          })
          .catch(() => receive());
      }

      const setIntervalfunc = () => {
        interval = true;
        receive();
      };
    };
    receive();

    return promise;
  }

  deleteApiMessage(sessionId, fnc, ReceiptHandle) {
    const formdata = new FormData();
    formdata.append("Action", "DeleteMessage");
    formdata.append("ReceiptHandle", ReceiptHandle);
    console.log("delete");

    let response_queue = this.scoreQueueURL(fnc, sessionId)

    // if (isCountryXMLAvailable()) {
    //   response_queue = userResponseQueue()
    // }

    const prm = this
      .sqsDeleteMessage(response_queue, ReceiptHandle)
      .then((xml) => {
        if (xml.includes("ResponseMetadata")) {
          return true;
        }
        return null;
      })
      .catch(() => false);
    return prm;
  }

  scoreQueueName(fnc, sessionId) {
    return `oileg-${fnc}-${sessionId}`;
  }

  scoreQueueURL(fnc, sessionId, givenQueueName) {
    const queuename = givenQueueName || this.scoreQueueName(fnc, sessionId);
    return this.reportsqs + queuename;
  }

  uploadSQSPayloadToS3(fnc, sessionId, payload) {
    const fileName = this.scoreQueueName(fnc, sessionId);
    const path = `oneintel/sqspayload/${fileName}.json`;
    return this.uploadFile(path, JSON.stringify(payload), {}).then(() => (path));
  }

  setFeatureAccess(details) {
    const { dispatch } = store
    if (isAdmin()) {
      dispatch(setModeOptionStatus({
        key: "dev", disabled: false
      }))
      dispatch(setModeOptionStatus({
        key: "flushcache", disabled: false
      }))
    }
    Object.values(details?.appDetails?.feature || {}).forEach((obj) => {
      if (obj.name === "Insights") {
        dispatch(setHasAccessToInsightsFeature(true))
      } else if (obj.name === "Personas") {
        dispatch(setHasAccessToPersonasFeature(true))
      } else if (obj.name === "Scrape-Topic/Brand") {
        dispatch(setHasAccessToScrapeTopicBrandFeature(true))
      } else if (obj.name === "Dev-mode") {
        dispatch(setModeOptionStatus({
          key: "dev", disabled: false
        }))
      } else if (obj.name === "FlushCache-mode") {
        dispatch(setModeOptionStatus({
          key: "flushcache", disabled: false
        }))
      } else if (obj.name === "Whitelabel") {
        // dispatch(setIsWhitelabel(true))
      }
    })

    dispatch(setDisabledMOKB(!!details?.appDetails?.feature?.[76])) //Disabled MOKB
  }

  userDetails(details) {
    if (details) this.userDetailsCache = details;
    return this.userDetailsCache
  }

  getUserGroup() {
    const { usergroupName } = this.userDetailsCache.signedUsergroup;
    return usergroupName.split("~")[0]
  }

  getAccount() {
    const { code } = this.userDetailsCache.accountDetails;
    return code
  }

  get(parameters) {
    const { path, params = {}, options, forcePath, callBackGetUrl = () => { } } = parameters
    const url = forcePath || `${this.url}${path}`
    callBackGetUrl(url);
    const { apiCancel, apiPromise } = SqAPI.get(url, params, options)
    return apiPromise.then((resp) => resp.data)
  }

  apiMonitoring(params = {}, isBypass) {
    return SqAPI.apiMonitoring(params, isBypass);
  }

  put(url, params = {}, options) {
    const { apiCancel, apiPromise } = SqAPI.put(url, params, options);
    return apiPromise
  }

  api(parameters) {
    const { method, url, params = {}, options } = parameters
    const { apiCancel, apiPromise } = SqAPI.api(method, url, params, options);
    return apiPromise
  }

  sqsSendMessage(QueueUrl, MessageBody, MessageAttributes, DelaySeconds, sqsParams, retry) {
    const params = [QueueUrl, MessageBody, MessageAttributes, DelaySeconds, sqsParams, retry]
    return SqAPI.sqsSendMessage(...params).catch((e) => {
      if (e.code === 'ExpiredTokenException') {
        return SqAPI.refreshToken((isTokenError, tokenError) => {
          if (isTokenError) return tokenError;
          return this.sqsSendMessage(...params)
        });
      }
    })
  }

  sqsCreateQueue(QueueName = "", Attributes = {}, tags = {}, retry = 0) {
    const params = [QueueName, Attributes, tags, retry]
    return SqAPI.sqsCreateQueue(...params).catch((e) => {
      if (e.code === 'ExpiredTokenException') {
        return SqAPI.refreshToken((isTokenError, tokenError) => {
          if (isTokenError) return tokenError;
          return this.sqsCreateQueue(...params)
        });
      }
    })
  }

  sqsReceiveMessage(QueueUrl = "", MaxNumberOfMessages = 1, WaitTimeSeconds = {}, sqsParams = {}, retry) {
    const params = [QueueUrl, MaxNumberOfMessages, WaitTimeSeconds, sqsParams, retry]
    return SqAPI.sqsReceiveMessage(...params).catch((e) => {
      if (e.code === 'ExpiredTokenException') {
        return SqAPI.refreshToken((isTokenError, tokenError) => {
          if (isTokenError) return tokenError;
          return this.sqsReceiveMessage(...params)
        });
      }
    })
  }

  sqsDeleteMessage(QueueUrl = "", ReceiptHandle = "", retry) {
    const params = [QueueUrl, ReceiptHandle, retry]
    return SqAPI.sqsDeleteMessage(...params).catch((e) => {
      if (e.code === 'ExpiredTokenException') {
        return SqAPI.refreshToken((isTokenError, tokenError) => {
          if (isTokenError) return tokenError;
          return this.sqsDeleteMessage(...params)
        });
      }
    })
  }

  post(url, params = {}, options) {
    const { apiCancel, apiPromise } = SqAPI.post(url, params, { noCredentials: true, ...options });
    return apiPromise
  }

  getPermission(type, otherParams = {}, featureKey) {
    const { id, signedUsergroup: {
      usergroupId
    } } = this.userDetails();

    const { startMonitor, endMonitor } = TrackFeatureServices.getMonitor({ featureKey })

    const params = {
      type,
      idUser: id,
      idUsergroup: usergroupId,
      ...otherParams
    }
    let usedUrl = ""
    const callBackGetUrl = (url) => {
      usedUrl = url
      startMonitor(params, { url: usedUrl })
    }

    return this.get({
      path: this.permissionPath, params, callBackGetUrl
    }).then((resp) => {
      endMonitor(resp, { url: usedUrl })
      return resp
    })
  }

  getKeywordDetails(treePath) {
    const enterpriseCode = getCountryCode("enterprise");
    const path = treePath.replace(enterpriseCode, enterpriseCode.toLocaleUpperCase()).replace(/\//g, "\\");
    const { username } = this.userDetails();
    return this.post(
      this.url + "oneintel/keywords/listkeyworddetails",
      {
        country: enterpriseCode.toLocaleUpperCase(),
        paths: [
          path
        ],
        levels: [],
        username,
        _class: "Keywords",
        _function: "ListKeywordDetails"
      }
    ).then((response) => {
      if (response?.data && response?.data?.url) {
        const { url } = response.data;
        const { promise, resolve } = createPromise();
        const startimport = function () {
          this.get({ path: url }).then((resp) => {
            let progress = resp.progress.toFixed(2);
            progress = Number(progress);
            if (resp.status === "processing" && progress <= 100) {
              setTimeout(() => {
                startimport(url);
              }, 1000);
            } else if (resp.status === "done" && progress === 100) {
              resolve({ data: resp.data.row, path });
            }
          });
        };
        if (url) startimport(url);
        else resolve(null);

        return promise;
      }
      return null;
    }).catch((rep) => {
      return null
    })
  }
}
export default new MainServices();
